// Portfolio content. Placeholder-ready — swap text, images and links freely.

export const PROFILE = {
  name: "MONICA WU",
  firstName: "Monica Wu",
  role: ["MONICA", "WU"],
  tagline:
    "Public Relations student at Boston University, Division I golfer, and aspiring marketing & communications professional building brands with precision and heart.",
  location: "Boston, Massachusetts",
  email: "monica.wu122@outlook.com",
  linkedin: "https://www.linkedin.com/in/monica-wu-289231374",
  instagram: "https://www.instagram.com/_monicaawu/",
  resume: "https://monica-wu-resume.tiiny.site",
  availability: "Open to 2027 internships",
};

export const STATS = [
  { value: "4.0", label: "GPA · PR Major" },
  { value: "D-I", label: "NCAA Golfer" },
  { value: "C-Suite", label: "Presented to Fortinet Execs" },
  { value: "2", label: "Marketing Internships" },
];

export const ABOUT_PARAGRAPHS = [
  "Most people see golf as an individual sport. I see it as a masterclass in risk management, discipline, and strategy under pressure — skills that translate directly to public relations.",
  "I'm a Public Relations major and Division I golfer at Boston University who specializes in bridging the gap between big-picture brand strategy and execution. Whether I'm leveraging generative AI to accelerate creative production timelines for a global cybersecurity brand like Fortinet, analyzing competitor gaps to refine market positioning, or advocating for student-athletes to campus executives, I bring the same standard: relentless focus, meticulous detail, and empathy.",
  "Fluent in English and Mandarin, I build brand narratives designed to cross cultures seamlessly.",
];

export const PROJECTS = [
  {
    id: "fortinet-founders-exhibit",
    title: "The Fortinet Founders Exhibit",
    category: "Experiential Marketing",
    year: "2027",
    image: "/images/fortinet-exhibit.jpg",
    overview:
      "An interactive brand experience for the 2027 Fortinet Founders Cup, designed to help golf fans understand Fortinet beyond its title sponsorship — a five-station exhibit combining LPGA history, Fortinet storytelling, a cybersecurity game, a careers wall, and an interactive passport program.",
    role: "Experiential Marketing Intern — U.S. Events, Programs & Logistics Team",
    process:
      "Analyzed the 2026 tournament experience and researched activations at other professional golf events, then designed the five-station Founders Exhibit: a '13 Founders' history wall, Fortinet brand storytelling, a kiosk-based cybersecurity hacking game, a careers wall, and a stamp-collecting passport program with rewards and a grand prize raffle. Used AI tools for concept development and visual mockups, built the budget and partner-integration plan, and developed Instagram and LinkedIn social rollout strategies.",
    skills: [
      "Experiential Marketing",
      "Audience Research",
      "AI-Assisted Design",
      "Engagement Planning",
      "Executive Presentation",
    ],
    results: [
      "Presented the strategy to Fortinet's CFO and VP of Marketing",
      "Gained cross-functional feedback across marketing, recruiting and sales",
      "Identified opportunities to grow brand engagement and pipeline ahead of the March 2027 event",
    ],
    accent: "#5E7E9B",
    gallery: [
      { src: "/images/fortinet/overview.jpg", caption: "The five-station exhibit experience — full concept overview" },
      { src: "/images/fortinet/founders-wall.jpg", caption: "The Founders wall — honoring the 13 women who changed the game of golf" },
      { src: "/images/fortinet/journey-impact.jpg", caption: "The Journey of Impact — LPGA and Fortinet legacy timeline" },
      { src: "/images/fortinet/careers-wall.jpg", caption: "Leading the Future — careers wall connecting fans to Fortinet opportunities" },
      { src: "/images/fortinet/hacking-game.jpg", caption: "Hacking Game station — a 5-minute kiosk cyber-defense challenge" },
      { src: "/images/fortinet/breaking-barriers.jpg", caption: "Breaking Barriers — interactive visitor reflection wall" },
      { src: "/images/fortinet/photobooth.jpg", caption: "Photo booth activation — share-your-legacy branded moment" },
      { src: "/images/fortinet/passport.jpg", caption: "Founders Passport — stamp program driving visits to all 5 stations" },
    ],
  },
];


export const SKILLS = [
  {
    category: "Creative & Brand Strategy",
    items: [
      { name: "Brand Storytelling & Positioning", desc: "Translating corporate goals into human-centric brand messaging" },
      { name: "Generative AI & Prompt Engineering", desc: "Accelerating design, video narratives, and asset production with AI tools" },
      { name: "Event Activation & Concept Design", desc: "Conceptualizing interactive brand exhibits and flagship event experiences" },
      { name: "Digital Content Creation", desc: "Digital media assets, 3D layouts, and visual communications with tools like Canva" },
      { name: "Crisis Communications", desc: "Managing messaging under pressure" },
      { name: "Campaign Analytics & Measurement", desc: "Tracking engagement, impressions, and performance metrics" },
    ],
  },
  {
    category: "Research & Strategic Marketing",
    items: [
      { name: "Competitive Intelligence & Gap Analysis", desc: "Analyzing competitor positioning to inform value propositions and GTM strategy" },
      { name: "Audience Research & Insights", desc: "Translating user and client data into actionable marketing outreach" },
      { name: "Bilingual Communications", desc: "Professional fluency in Mandarin and English for global audiences" },
      { name: "Social Media Strategy & Management", desc: "Content calendars, platform-specific strategy, and community engagement" },
      { name: "SEO & Content Marketing", desc: "Content strategy that drives inbound leads and audience discovery" },
    ],
  },
  {
    category: "Leadership & Executive Presence",
    items: [
      { name: "Executive Pitching & Stakeholder Presentation", desc: "Presenting concepts to marketing executives and Boards to secure buy-in" },
      { name: "Cross-Functional Collaboration", desc: "Partnering across departments, varsity teams, and student bodies" },
      { name: "Stakeholder Advocacy & Representation", desc: "Liaison between leadership and 600+ student-athletes, 1,300+ students" },
      { name: "Change Management & Internal Comms", desc: "Aligning messaging across stakeholders through operational shifts" },
    ],
  },
  {
    category: "Execution & Operations",
    items: [
      { name: "Project Management & Deadline Execution", desc: "Coordinating timelines, budgets, agendas, and fundraisers under pressure" },
      { name: "Technical Proficiency", desc: "Microsoft Office Suite (Excel, PowerPoint, Word) and Canva" },
      { name: "CRM & Sales Enablement Tools", desc: "Salesforce, HubSpot, and LinkedIn Sales Navigator" },
      { name: "Agile Project Tools", desc: "Asana, Trello, and Notion for organized team workflows" },
    ],
  },
];
